const Styles = {
    personalData: {
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        '& > div': {
            width: "48%",
            marginRight: 20,
        },
        borderBottom: '1px solid grey',
        marginBottom: 40
    },
    documents: {
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        marginBottom: 40,
        paddingBottom: 10,
        borderBottom: '1px solid grey',
        '& > div > ul > li > section': {
            display: "flex",
            flexWrap: "wrap",
            //width: "100%",
            '& > div': {
                width: "45%",
                marginLeft: 20,
                '& > div': {
                    width: "100%"
                }
            }
        },
        '& > div > ul > li > span': {
            width: '30%'
        }
    },
    phones: {
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        marginBottom: 40,
        paddingBottom: 10,
        borderBottom: '1px solid grey',
        '& > div > ul > li > section': {
            display: "flex",
            flexWrap: "wrap",
            //width: "100%",
            '& > div': {
                width: "48%",
                //marginRight: 20,
                '& > div': {
                    width: "100%"
                }
            }
        },
        '& > div > ul > li > span': {
            width: '30%'
        }
    },
    contacts: {
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        marginBottom: 40,
        paddingBottom: 10,
        borderBottom: '1px solid grey',
        '& > h6': {
            width: "100%"
        },
        '& > div > ul > li > section': {
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            '& > div': {
                width: "45%",
                marginLeft: 20,
                '& > div': {
                    width: "100%"
                }
            }
        },
        '& > div > ul > li > span': {
            width: '30%'
        }
    },
    separator: {
        width: '10px',
        clear: 'none'
    },
    controlPanel: {
        width: "100%"
    }
};

export default Styles;
